function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6F3FC"
    },
    d: "M172.43,357.272c-35.471-7.747-55.857,18.347-101.928,4.892 c-31.312-9.144-30.401-40.508-27.229-56.301c6.142-30.583,39.009-48.998,49.518-78.368 c7.889-22.047-7.41-116.369,43.836-139.473c51.246-23.103,91.159,26.489,133.321,25.768c42.162-0.72,93.64-46.633,129.94-12.278 c29.639,28.052-2.894,72.039,1.458,98.003c3.89,23.21,23.014,31.93,44.253,49.712c17.532,14.678,26.094,49.333,2.854,75.835 c-24.231,27.631-78.115,16.171-110.919,26.089c-38.238,11.56-50.069,47.701-76.92,48.019 C218.094,399.674,207.901,365.018,172.43,357.272z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6F3FC"
    },
    d: "M337.283,77.892c1.426,7.088-8.117,14.986-21.314,17.641c-13.198,2.655-25.053-0.938-26.479-8.025 c-1.426-7.088,8.117-14.986,21.314-17.641C324.002,67.212,335.857,70.804,337.283,77.892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6F3FC"
    },
    d: "M363.04,75.478c0,2.992-2.425,5.417-5.417,5.417c-2.992,0-5.417-2.425-5.417-5.417 c0-2.992,2.425-5.417,5.417-5.417C360.615,70.061,363.04,72.486,363.04,75.478z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E6F3FC"
    },
    cx: 98.973,
    cy: 87.214,
    r: 17.153
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6F3FC"
    },
    d: "M129.668,73.672c0,3.241,2.627,5.868,5.868,5.868c3.241,0,5.868-2.627,5.868-5.868 s-2.627-5.868-5.868-5.868C132.296,67.804,129.668,70.432,129.668,73.672z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4609 -0.8875 0.8875 0.4609 33.784 517.7734)",
    style: {
      fill: "#E6F3FC"
    },
    cx: 443.038,
    cy: 231.081,
    rx: 18.009,
    ry: 24.679
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E6F3FC"
    },
    cx: 469.718,
    cy: 262.43,
    r: 4.669
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9239 -0.3827 0.3827 0.9239 -95.9121 43.7578)",
    style: {
      fill: "#E6F3FC"
    },
    cx: 62.037,
    cy: 262.971,
    rx: 24.036,
    ry: 24.036
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6F3FC"
    },
    d: "M71.214,217.52c0,3.379-2.739,6.118-6.118,6.118c-3.379,0-6.118-2.739-6.118-6.118 c0-3.379,2.739-6.118,6.118-6.118C68.475,211.402,71.214,214.141,71.214,217.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6F3FC"
    },
    d: "M50.237,231.068c0,2.655-2.152,4.807-4.807,4.807c-2.655,0-4.807-2.152-4.807-4.807 s2.152-4.807,4.807-4.807C48.085,226.26,50.237,228.413,50.237,231.068z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E6F3FC"
    },
    cx: 80.829,
    cy: 380.967,
    r: 10.052
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E6F3FC"
    },
    cx: 193.144,
    cy: 380.967,
    r: 5.681
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E6F3FC"
    },
    cx: 430.011,
    cy: 352.561,
    r: 22.725
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1597 -0.9872 0.9872 0.1597 65.463 741.8196)",
    style: {
      fill: "#E6F3FC"
    },
    cx: 468.47,
    cy: 332.457,
    rx: 9.615,
    ry: 9.614
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6F3FC"
    },
    d: "M470.655,363.923c0,2.655-2.152,4.807-4.807,4.807c-2.655,0-4.807-2.152-4.807-4.807 s2.152-4.807,4.807-4.807C468.503,359.116,470.655,361.268,470.655,363.923z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#0082CA",
      strokeMiterlimit: 10
    },
    d: "M376.837,330.636c0,0,36.706-32.583,51.854-89.288"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M422.579,261.834c0,0-12.03-25.028-4.01-29.038C426.589,228.787,422.579,261.834,422.579,261.834z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M428.32,242.888c0,0-1.361-27.735,7.587-28.314C444.854,213.995,428.32,242.888,428.32,242.888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M421.443,262.93c0,0,18.425-20.775,25.225-14.931C453.469,253.842,421.443,262.93,421.443,262.93z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M412.583,282.985c0,0-9.159-26.215-0.741-29.304C420.259,250.592,412.583,282.985,412.583,282.985 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M410.106,286.727c0,0,19.456-19.813,25.951-13.631 C442.552,279.278,410.106,286.727,410.106,286.727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M402.876,299.146c0,0,23.274-15.147,28.281-7.708 C436.165,298.875,402.876,299.146,402.876,299.146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M399.002,304.762c0,0-6.345-27.034,2.351-29.219C410.049,273.359,399.002,304.762,399.002,304.762 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M387.139,320.393c0,0,19.237-20.026,25.799-13.916C419.5,312.587,387.139,320.393,387.139,320.393 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#0082CA",
      strokeWidth: 0.7565,
      strokeMiterlimit: 10
    },
    d: "M371.42,355.675 c0,0,37.066,2.212,75.507-20.013"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M432.697,343.349c0,0,6.956-19.823,13.391-17.677 C452.524,327.819,432.697,343.349,432.697,343.349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M445.904,336.287c0,0,14.111-15.563,19.207-11.085 C470.207,329.679,445.904,336.287,445.904,336.287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M431.503,343.327c0,0,20.97-1.254,21.481,5.51C453.494,355.602,431.503,343.327,431.503,343.327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M416.034,349.313c0,0,9.127-18.922,15.282-16.07C437.471,336.095,416.034,349.313,416.034,349.313 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M412.707,349.99c0,0,21.007-0.188,21.173,6.594C434.047,363.365,412.707,349.99,412.707,349.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M402.196,352.764c0,0,20.552,4.351,19.251,11.009C420.145,370.43,402.196,352.764,402.196,352.764 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M397.118,353.695c0,0,11.071-17.854,16.891-14.37 C419.829,342.809,397.118,353.695,397.118,353.695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M382.41,355.708c0,0,21.004-0.419,21.245,6.361C403.896,368.848,382.41,355.708,382.41,355.708z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#0082CA",
      strokeWidth: 0.8133,
      strokeMiterlimit: 10
    },
    d: "M119.86,328.293 c0,0-31.606-24.381-47.07-69.541"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M78.896,275.032c0,0,8.359-20.98,1.628-23.784C73.792,248.443,78.896,275.032,78.896,275.032z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M73.178,259.981c0,0-0.448-22.579-7.741-22.548C58.145,237.464,73.178,259.981,73.178,259.981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M79.879,275.857c0,0-16.112-15.824-21.303-10.702S79.879,275.857,79.879,275.857z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M88.191,291.633c0,0,5.964-21.782-1.039-23.817C80.149,265.781,88.191,291.633,88.191,291.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M90.409,294.53c0,0-16.895-14.986-21.818-9.607C63.668,290.303,90.409,294.53,90.409,294.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M96.971,304.201c0,0-19.731-10.986-23.378-4.671C69.947,305.846,96.971,304.201,96.971,304.201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M100.429,308.541c0,0,3.635-22.289-3.543-23.575C89.707,283.681,100.429,308.541,100.429,308.541z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M110.929,320.559c0,0-16.729-15.171-21.711-9.846C84.235,316.038,110.929,320.559,110.929,320.559 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004F85"
    },
    d: "M129.795,327.349c-1.993-0.007-8.349,6.638-17.28,8.265c-8.931,1.627-23.33,2.934-36.634-5.792 c-13.304-8.725-19.316-19.771-24.667-32.984c-5.351-13.213-6.553-17.521-9.366-20.001c4.549,0.51,14.819-3.061,23.229-4.522 c8.41-1.461,25.282-1.463,42.459,9.675c17.177,11.138,22.523,30.595,22.328,35.922c-0.195,5.326,0.567,6.872,1.039,8.038 C131.374,327.116,129.795,327.349,129.795,327.349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00406B"
    },
    d: "M119.849,322.172c-4.438,5.895-16.519,11.456-24.168,14.412c1.033,0.094,2.05,0.152,3.051,0.184 c1.573-0.644,2.995-1.253,3.956-1.687c6.36-2.871,14.7-7.324,18.314-12.246l0.089-0.121l0.028-0.148 c1.942-10.371,2.223-18.481,1.892-24.423c-0.481-0.792-0.995-1.587-1.535-2.38C122.031,301.741,122.015,310.535,119.849,322.172z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00406B"
    },
    d: "M104.416,313.134c-6.168,6.406-22.555,13.718-28.94,16.416c0.135,0.09,0.267,0.182,0.404,0.272 c0.315,0.207,0.631,0.402,0.947,0.597c7.024-2.99,22.68-10.11,28.715-16.553l0.162-0.173l0.015-0.237 c0.573-8.999,0.497-16.23,0.141-21.877c-0.318-5.038-0.86-8.802-1.365-11.447c-0.513-0.296-1.026-0.581-1.538-0.858 C104.029,284.411,105.531,295.303,104.416,313.134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00406B"
    },
    d: "M88.524,304.136c-5.145,5.344-17.401,11.317-25.032,14.718c0.295,0.355,0.595,0.708,0.902,1.058 c7.814-3.488,20.076-9.513,25.256-15.044l0.161-0.173l0.015-0.237c0.573-8.999,0.497-16.23,0.141-21.878 c-0.226-3.575-0.564-6.505-0.922-8.857c-0.474-0.127-0.946-0.246-1.414-0.36C88.571,279.269,89.453,289.287,88.524,304.136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00406B"
    },
    d: "M75.395,296.088l0.015-0.237c0.573-8.999,0.497-16.23,0.141-21.878 c-0.051-0.801-0.108-1.56-0.169-2.298c-0.457-0.016-0.909-0.027-1.351-0.031c0.497,5.869,0.71,13.752,0.076,23.884 c-3.792,3.939-11.449,8.219-18.27,11.561c0.205,0.398,0.412,0.793,0.623,1.186c6.996-3.428,14.883-7.861,18.772-12.014 L75.395,296.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00406B"
    },
    d: "M60.657,287.501l0.015-0.237c0.339-5.322,0.449-10.02,0.411-14.144 c-0.442,0.099-0.884,0.198-1.328,0.302c0.035,3.968-0.069,8.461-0.385,13.519c-2.162,2.246-5.582,4.604-9.387,6.835 c0.162,0.406,0.329,0.823,0.5,1.249c4.056-2.374,7.726-4.911,10.013-7.352L60.657,287.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00406B"
    },
    d: "M139.785,333.265c0,0-25.821-13.886-38.763-21.381c-12.942-7.495-51.369-30.749-51.369-30.749 s46.959,26.723,52.357,29.944c5.398,3.222,35.754,18.361,38.675,20.121C141.774,331.856,141.245,333.819,139.785,333.265z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#02B6EC"
    },
    d: "M114.18,349.604c-0.776,1.083,0.38,7.119-2.195,12.613c-2.575,5.494-7.442,13.842-17.349,17.707 c-9.907,3.865-18.252,2.859-27.521,0.653c-9.269-2.206-12.081-3.22-14.522-2.649c2.04-2.28,4.075-9.257,6.538-14.403 c2.463-5.146,8.999-14.336,21.721-19.374c12.721-5.039,25.389-0.411,28.214,1.759c2.825,2.17,3.962,2.354,4.78,2.549 C114.666,348.653,114.18,349.604,114.18,349.604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009AD1"
    },
    d: "M107.508,353.014c1.491,4.701-0.162,13.435-1.516,18.746c0.451-0.526,0.878-1.058,1.282-1.591 c0.259-1.106,0.478-2.116,0.614-2.808c0.901-4.576,1.707-10.843,0.427-14.719l-0.031-0.096l-0.07-0.073 c-4.896-5.076-9.203-8.371-12.568-10.493c-0.618-0.045-1.25-0.073-1.891-0.086C97.226,343.909,102.009,347.326,107.508,353.014z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009AD1"
    },
    d: "M96.606,357.917c1.099,5.841-1.269,17.599-2.273,22.121c0.102-0.039,0.202-0.075,0.304-0.115 c0.234-0.091,0.463-0.188,0.692-0.284c1.093-4.984,3.282-16.269,2.111-22.052l-0.032-0.155l-0.123-0.1 c-4.679-3.799-8.646-6.56-11.86-8.553c-2.867-1.779-5.126-2.942-6.763-3.692c-0.36,0.165-0.714,0.334-1.063,0.505 C80.814,346.999,87.327,350.401,96.606,357.917z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009AD1"
    },
    d: "M85.548,363.085c0.917,4.873-0.579,13.861-1.684,19.336c0.308-0.023,0.616-0.05,0.925-0.082 c1.128-5.607,2.598-14.619,1.593-19.583l-0.032-0.155l-0.123-0.1c-4.679-3.799-8.647-6.56-11.86-8.553 c-2.035-1.262-3.762-2.213-5.181-2.929c-0.253,0.209-0.501,0.42-0.744,0.631C72.024,353.425,77.821,356.826,85.548,363.085z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009AD1"
    },
    d: "M76.077,367.117l-0.123-0.1c-4.679-3.799-8.646-6.56-11.86-8.553 c-0.456-0.283-0.892-0.546-1.317-0.798c-0.186,0.243-0.367,0.484-0.541,0.723c3.389,2.003,7.764,4.941,13.037,9.213 c0.676,3.591,0.04,9.419-0.783,14.429c0.296,0.042,0.592,0.083,0.887,0.12c0.844-5.139,1.485-11.151,0.731-14.879L76.077,367.117 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009AD1"
    },
    d: "M65.691,371.816l-0.123-0.1c-2.767-2.246-5.283-4.127-7.543-5.704 c-0.118,0.279-0.234,0.558-0.35,0.84c2.175,1.518,4.581,3.316,7.213,5.448c0.385,2.048,0.344,4.824,0.085,7.76 c0.284,0.069,0.576,0.14,0.874,0.212c0.279-3.129,0.319-6.11-0.124-8.301L65.691,371.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009AD1"
    },
    d: "M121.273,346.455c0,0-17.567,8.682-26.663,12.826s-36.65,16.061-36.65,16.061 s32.748-15.22,36.594-16.911c3.846-1.692,23.853-12.357,25.943-13.266C121.277,344.826,122.141,345.875,121.273,346.455z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#0082CA",
      strokeWidth: 0.7565,
      strokeMiterlimit: 10
    },
    d: "M133.795,315.164 c0,0-26.655,25.85-70.291,34.073"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M79.304,345.784c0,0-18.201-10.49-21.68-4.666C54.146,346.941,79.304,345.784,79.304,345.784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M64.686,349.044c0,0-20.847-2.594-21.79,4.123C41.954,359.885,64.686,349.044,64.686,349.044z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M80.195,344.988c0,0-16.715,12.726-12.69,18.187C71.529,368.635,80.195,344.988,80.195,344.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M95.826,339.438c0,0-19.259-8.391-22.065-2.216C70.954,343.398,95.826,339.438,95.826,339.438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M98.789,337.781c0,0-16.047,13.558-11.75,18.807C91.335,361.837,98.789,337.781,98.789,337.781z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M108.566,333.028c0,0-12.742,16.702-7.414,20.901 C106.481,358.127,108.566,333.028,108.566,333.028z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M113.022,330.422c0,0-20.036-6.315-22.176,0.123C88.707,336.982,113.022,330.422,113.022,330.422z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M125.485,322.356c0,0-16.195,13.381-11.956,18.677 C117.767,346.329,125.485,322.356,125.485,322.356z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004F85"
    },
    d: "M378.842,344.534c0.615-1.284-1.727-7.423-0.041-13.687c1.686-6.264,5.253-15.958,14.962-21.873 c9.708-5.915,18.68-6.411,28.849-5.817c10.169,0.594,13.318,1.138,15.78,0.081c-1.723,2.78-2.564,10.504-4.198,16.38 c-1.634,5.876-6.801,16.768-19.253,24.443c-12.452,7.675-26.65,5.166-30.028,3.408c-3.378-1.758-4.61-1.74-5.507-1.792 C378.509,345.625,378.842,344.534,378.842,344.534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00406B"
    },
    d: "M385.231,339.7c-2.446-4.671-2.334-14.173-1.899-20.016c-0.377,0.638-0.727,1.277-1.053,1.914 c-0.066,1.212-0.108,2.317-0.123,3.07c-0.095,4.984,0.225,11.733,2.294,15.573l0.051,0.095l0.087,0.064 c6.1,4.431,11.248,7.097,15.185,8.703c0.659-0.068,1.329-0.156,2.007-0.262C397.751,347.368,392.079,344.663,385.231,339.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00406B"
    },
    d: "M395.793,332.507c-2.246-5.944-1.945-18.762-1.731-23.71c-0.1,0.06-0.199,0.116-0.299,0.177 c-0.23,0.14-0.453,0.284-0.676,0.428c-0.222,5.45-0.422,17.737,1.888,23.607l0.062,0.157l0.148,0.082 c5.633,3.127,10.325,5.293,14.079,6.793c3.35,1.338,5.945,2.142,7.807,2.626c0.348-0.241,0.689-0.484,1.025-0.73 C414.452,341.057,406.962,338.69,395.793,332.507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00406B"
    },
    d: "M406.47,325.005c-1.873-4.958-1.974-14.699-1.832-20.668c-0.32,0.082-0.639,0.168-0.959,0.258 c-0.142,6.112-0.01,15.873,1.973,20.911l0.062,0.157l0.148,0.083c5.633,3.126,10.325,5.293,14.079,6.793 c2.377,0.95,4.372,1.629,6,2.118c0.227-0.267,0.449-0.535,0.665-0.802C422.507,332.654,415.771,330.154,406.47,325.005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00406B"
    },
    d: "M415.688,318.996l0.148,0.082c5.633,3.126,10.325,5.293,14.079,6.793 c0.532,0.213,1.04,0.408,1.535,0.595c0.15-0.29,0.296-0.578,0.434-0.862c-3.941-1.477-9.094-3.754-15.441-7.268 c-1.381-3.654-1.798-9.908-1.865-15.335c-0.319,0.01-0.638,0.023-0.956,0.039c0.07,5.566,0.515,12.015,2.004,15.798 L415.688,318.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00406B"
    },
    d: "M425.745,312.113l0.148,0.082c3.331,1.849,6.33,3.36,9.004,4.598 c0.072-0.315,0.143-0.631,0.212-0.95c-2.572-1.193-5.441-2.636-8.608-4.39c-0.787-2.084-1.262-5.014-1.536-8.153 c-0.312-0.02-0.632-0.04-0.959-0.06c0.29,3.345,0.803,6.492,1.678,8.715L425.745,312.113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00406B"
    },
    d: "M371.963,349.17c0,0,16.874-12.414,25.677-18.471c8.803-6.058,35.586-23.739,35.586-23.739 s-31.636,22.126-35.37,24.623c-3.733,2.498-22.806,17.454-24.836,18.801C372.263,350.886,371.158,349.943,371.963,349.17z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#D4E2E9"
    },
    cx: 248.314,
    cy: 408.843,
    rx: 128,
    ry: 8.774
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0082CA"
    },
    points: "279.486,369.273 220.541,369.273 210.658,405.001 289.369,405.001  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#005995"
    },
    points: "279.486,369.273 220.541,369.273 217.934,378.699 282.093,378.699  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#005995"
    },
    points: "210.658,405.001 289.369,405.001 287.441,398.034 212.586,398.034  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M297.245,402.643h-94.826c-1.66,0-3.005,1.345-3.005,3.005v2.436H300.25v-2.436 C300.25,403.989,298.905,402.643,297.245,402.643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M102.538,345.753v18.174c0,4.335,3.514,7.849,7.85,7.849h279.225c4.336,0,7.849-3.514,7.849-7.849 v-18.174H102.538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002B54"
    },
    d: "M397.462,177.999c0-4.335-3.513-7.849-7.849-7.849H110.388c-4.336,0-7.85,3.514-7.85,7.849 v167.754h294.923V177.999z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.897,
    y: 180.617,
    style: {
      fill: "#434C5A"
    },
    width: 273.853,
    height: 154.435
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00B6EC"
    },
    points: "386.68,334.959 386.751,180.802 249.824,180.71 249.824,334.959  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFF9C7"
    },
    points: "112.968,180.71 112.897,334.867 249.824,334.959 249.824,180.71  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00B4EC"
    },
    d: "M255.242,358.095c0,2.589-2.099,4.688-4.688,4.688c-2.589,0-4.688-2.099-4.688-4.688 s2.099-4.688,4.688-4.688C253.143,353.408,255.242,355.506,255.242,358.095z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.14,
      fill: "#FFFFFF"
    },
    d: "M397.462,177.999c0-4.335-3.513-7.849-7.849-7.849H110.388 c-2.207,0-4.198,0.914-5.624,2.38l292.698,160.298V177.999z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 316.1784,
    y1: 307.4554,
    x2: 316.6452,
    y2: 324.4953
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D88D10"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E19F0C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M278.874,334.959h76.117c0,0-4.81-32.979-4.81-63.178s-65.759-35.962-65.759-0.246 C284.421,307.251,278.874,334.959,278.874,334.959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006792"
    },
    d: "M306.055,315.844c-9.677,2.389-18.159,12.305-17.801,19.115c33.093,0,59.615,0,59.615,0 s-2.031-13.978-18.276-18.614C318.409,313.154,306.055,315.844,306.055,315.844"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F3D8BE"
    },
    cx: 317.358,
    cy: 317.651,
    rx: 10.174,
    ry: 4.041
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    style: {
      fill: "#00527B"
    },
    d: "M317.798,321.021c-7.235,0-8.342-4.306-8.308-5.894 c-2.567,0.101-3.817,0.844-3.817,0.844s1.718,8.309,12.193,8.056c10.476-0.253,11.866-7.682,11.866-7.682 s-0.312-0.34-1.799-0.644c-1.309-0.268-2.094-0.236-2.094-0.236S325.033,321.021,317.798,321.021z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00527B"
    },
    d: "M295.377,321.76c-4.427,4.009-7.336,9.153-7.123,13.2c33.093,0,59.615,0,59.615,0 s-0.626-4.275-3.928-8.88C322.372,335.868,301.776,328.736,295.377,321.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D8BE"
    },
    d: "M321.721,317.543c-1.214,3.053-4.385,2.479-4.385,2.479s-3.383-0.573-4.346-2.389 c-0.666-1.257,0-12.397,0-12.397h8.731C321.721,305.235,322.054,316.707,321.721,317.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEC69E"
    },
    d: "M321.865,313.382c-0.014-3.581-0.146-8.147-0.146-8.147h-8.731c0,0-0.281,4.726-0.294,8.37 C315.711,312.687,319.439,312.819,321.865,313.382z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D8BE"
    },
    d: "M347.027,276.107c-0.157,0-0.305,0.033-0.458,0.046c-2.256-14.227-14.541-25.114-29.402-25.114 c-14.853,0-27.133,10.876-29.398,25.091c-0.079-0.003-0.152-0.023-0.232-0.023c-2.932,0-5.309,2.377-5.309,5.309 c0,2.932,2.377,5.309,5.309,5.309c0.138,0,0.268-0.03,0.404-0.041c2.715,13.665,14.764,23.969,29.227,23.969 c14.471,0,26.524-10.315,29.231-23.992c0.209,0.025,0.414,0.064,0.629,0.064c2.932,0,5.309-2.377,5.309-5.309 C352.336,278.484,349.959,276.107,347.027,276.107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8BCAE"
    },
    d: "M295.654,286.696c0,0.832,1.92,1.506,4.287,1.506c2.368,0,4.288-0.674,4.288-1.506 c0-0.832-1.92-1.506-4.288-1.506C297.573,285.19,295.654,285.864,295.654,286.696z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F8BCAE"
    },
    cx: 336.341,
    cy: 286.696,
    rx: 4.287,
    ry: 1.506
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.54,
      fill: "#EEC69E"
    },
    d: "M347.027,286.725c2.932,0,5.309-2.377,5.309-5.309c0-2.932-2.377-5.309-5.309-5.309 c-0.157,0-0.305,0.033-0.458,0.046c-2.256-14.227-14.541-25.114-29.402-25.114c-12.33,0-22.866,7.505-27.392,18.183 c26.526-1.905,47.059,11.261,55.124,22.532c0.643-1.633,1.151-3.334,1.499-5.093 C346.606,286.687,346.811,286.725,347.027,286.725z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127729537810906827010000007335488934720862390_",
    gradientUnits: "userSpaceOnUse",
    x1: 1341.9546,
    y1: 273.5216,
    x2: 1341.9546,
    y2: 286.1163,
    gradientTransform: "matrix(-1 0 0 1 1648.6053 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEAD81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EEC69E",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.61,
      fill: "url(#SVGID_00000127729537810906827010000007335488934720862390_)"
    },
    d: "M313.725,272.079 c1.168,4.504-0.493,14.069-6.87,14.069s-7.779-8.143-7.612-12.369C305.516,268.854,313.725,272.079,313.725,272.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F49A14"
    },
    d: "M314.239,272.983c0,0-8.722-3.424-17.191,2.394c5.38-6.503,14.271-5.184,15.431-4.687 C314.299,271.468,314.239,272.983,314.239,272.983z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098216352844095536050000015722577564128923583_",
    gradientUnits: "userSpaceOnUse",
    x1: 1337.5352,
    y1: 282.7402,
    x2: 1339.3948,
    y2: 281.3053,
    gradientTransform: "matrix(-1 0 0 1 1648.6053 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#220900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4B211C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098216352844095536050000015722577564128923583_)"
    },
    d: "M308.966,282.023 c0,0.649,0.526,1.174,1.174,1.174c0.648,0,1.174-0.526,1.174-1.174c0-0.648-0.526-1.174-1.174-1.174 C309.492,280.848,308.966,281.374,308.966,282.023z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102536843826561359160000000619017330575368576_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.8703,
    y1: 309.2478,
    x2: 371.6947,
    y2: 257.1357
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B301"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FECA00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102536843826561359160000000619017330575368576_)"
    },
    d: "M347.49,276.725c0,0,0,6.199-0.51,7.388 c-0.509,1.189-1.613-6.029-1.302-9.681C346.352,271.363,347.822,273.536,347.49,276.725z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132780055004295709660000013413998276262897542_",
    gradientUnits: "userSpaceOnUse",
    x1: 285.7429,
    y1: 279.9189,
    x2: 346.567,
    y2: 227.8069
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B301"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FECA00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132780055004295709660000013413998276262897542_)"
    },
    d: "M287.989,274.432 c0.311,3.652-0.793,10.87-1.302,9.681c-0.51-1.189-0.51-7.388-0.51-7.388C285.044,274.106,287.223,273.146,287.989,274.432z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013871286777303414940000003864330668280657329_",
    gradientUnits: "userSpaceOnUse",
    x1: 330.0965,
    y1: 273.5216,
    x2: 330.0965,
    y2: 286.1163
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEAD81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EEC69E",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.61,
      fill: "url(#SVGID_00000013871286777303414940000003864330668280657329_)"
    },
    d: "M323.022,272.079 c-1.168,4.504,0.493,14.069,6.87,14.069s7.779-8.143,7.612-12.369C331.231,268.854,323.022,272.079,323.022,272.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F49A14"
    },
    d: "M322.508,272.983c0,0,8.722-3.424,17.191,2.394c-5.38-6.503-14.271-5.184-15.431-4.687 C322.448,271.468,322.508,272.983,322.508,272.983z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155113142159534626960000016225354192411630996_",
    gradientUnits: "userSpaceOnUse",
    x1: 325.677,
    y1: 282.7402,
    x2: 327.5366,
    y2: 281.3053
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#220900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4B211C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155113142159534626960000016225354192411630996_)"
    },
    d: "M327.781,282.023 c0,0.649-0.526,1.174-1.174,1.174c-0.649,0-1.174-0.526-1.174-1.174c0-0.648,0.526-1.174,1.174-1.174 C327.255,280.848,327.781,281.374,327.781,282.023z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150797312776031187550000014291370798404402605_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.7086,
    y1: 285.0783,
    x2: 349.5444,
    y2: 234.6699
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B301"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FECA00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150797312776031187550000014291370798404402605_)"
    },
    d: "M288.319,273.437 c27.887-1.075,38.231-14.675,42.083-19.04c-2.054,10.015,3.852,12.326,7.19,8.217c1.798,9.501,8.988,14.637,8.988,14.637 l3.552,0.123c0,0,4.124-5.162,0.627-20.471c-3.122-13.666-7.567-16.598-12.693-19.528c-4.365-8.731-35.693-11.985-46.735,5.22 c-11.042,17.205-7.262,34.91-7.262,34.91s1.845,1.392,2.936-0.255S288.319,273.437,288.319,273.437z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A48A"
    },
    d: "M319.447,278.346c0.145,1.568,0.305,3.124,0.513,4.658c0.114,0.765,0.233,1.528,0.411,2.264 c0.184,0.724,0.396,1.475,0.773,1.994l-0.328-0.19c0.582,0.07,1.128,0.24,1.636,0.493c0.508,0.252,0.993,0.569,1.397,1.054 c0.195,0.246,0.37,0.565,0.397,0.959c0.036,0.399-0.181,0.81-0.4,1.019c-0.448,0.465-0.982,0.709-1.521,0.87 c-1.084,0.317-2.197,0.27-3.239,0.055c-1.04-0.239-2.031-0.617-2.939-1.132c0.996,0.308,1.997,0.578,3.012,0.649 c1.004,0.093,2.026,0.027,2.923-0.304c0.439-0.169,0.866-0.406,1.124-0.71c0.138-0.167,0.163-0.26,0.149-0.386 c-0.013-0.126-0.098-0.285-0.224-0.442c-0.552-0.636-1.542-1.052-2.424-1.183l-0.223-0.033l-0.105-0.157 c-0.519-0.776-0.722-1.577-0.874-2.372c-0.149-0.795-0.23-1.589-0.265-2.382c-0.043-0.792-0.035-1.583-0.004-2.371 C319.286,279.913,319.326,279.126,319.447,278.346z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A48A"
    },
    d: "M317.62,288.506c0.271-0.284,0.634-0.461,0.998-0.594c0.368-0.134,0.755-0.189,1.141-0.237 c0.763-0.026,1.612,0.051,2.224,0.569c-0.38-0.075-0.74-0.113-1.104-0.122c-0.363-0.007-0.725-0.012-1.086,0.032 c-0.364,0.006-0.723,0.065-1.084,0.115C318.347,288.323,317.99,288.394,317.62,288.506z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0851B"
    },
    d: "M333.514,248.147c0.961,0.329,1.825,0.903,2.627,1.546c0.757,0.689,1.472,1.441,2.06,2.281 c1.216,1.656,2.125,3.508,2.866,5.404c1.454,3.811,2.213,7.845,2.375,11.88c-0.443-1.972-0.9-3.926-1.401-5.861 c-0.531-1.927-1.113-3.836-1.832-5.688c-0.706-1.855-1.548-3.658-2.598-5.33C336.558,250.715,335.276,249.16,333.514,248.147z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0851B"
    },
    d: "M333.514,245.31c2.439,1.012,4.701,2.52,6.572,4.44c1.889,1.906,3.347,4.214,4.438,6.652 c1.076,2.451,1.807,5.034,2.254,7.649c0.455,2.615,0.685,5.256,0.699,7.896c-0.395-2.61-0.8-5.208-1.392-7.755 c-0.602-2.542-1.34-5.05-2.401-7.416c-1.038-2.373-2.411-4.592-4.113-6.545C337.866,248.275,335.78,246.661,333.514,245.31z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0851B"
    },
    d: "M335.175,242.113c1.462,0.297,2.927,0.789,4.205,1.618c0.319,0.205,0.655,0.392,0.957,0.622 l0.882,0.724c0.616,0.457,1.103,1.045,1.646,1.58c2.065,2.249,3.56,4.949,4.741,7.733c1.109,2.82,1.905,5.758,2.331,8.746 c0.422,2.987,0.533,6.017,0.23,9.003c-0.08-2.998-0.368-5.97-0.928-8.887c-0.562-2.913-1.335-5.789-2.484-8.515 c-1.083-2.747-2.542-5.353-4.421-7.618C340.462,244.869,338.06,242.987,335.175,242.113z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0851B"
    },
    d: "M332.629,247.307c-1.171,1.894-2.672,3.555-4.182,5.191c-1.58,1.569-3.222,3.083-4.969,4.469 c-3.478,2.794-7.277,5.178-11.25,7.214c-4.002,1.973-8.204,3.589-12.566,4.558c-4.353,0.986-8.827,1.428-13.264,1.189 c4.44-0.144,8.831-0.761,13.094-1.876c1.055-0.319,2.128-0.574,3.174-0.917l3.122-1.081l3.049-1.272 c1.016-0.425,1.985-0.954,2.98-1.423c3.955-1.941,7.698-4.304,11.228-6.948C326.561,253.755,329.909,250.818,332.629,247.307z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0851B"
    },
    d: "M332.629,244.958c-1.128,1.819-2.654,3.348-4.207,4.817c-1.625,1.391-3.32,2.712-5.126,3.864 c-3.589,2.344-7.476,4.202-11.473,5.736c-4.027,1.448-8.168,2.628-12.405,3.253c-4.232,0.636-8.517,0.866-12.772,0.624 c4.26-0.141,8.488-0.548,12.652-1.322c4.166-0.761,8.253-1.92,12.204-3.416c3.973-1.444,7.799-3.287,11.418-5.471 C326.517,250.845,329.991,248.315,332.629,244.958z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0851B"
    },
    d: "M332.382,242.61c-1.053,1.688-2.605,2.993-4.215,4.153c-0.852,0.509-1.678,1.078-2.579,1.497 l-1.33,0.675l-1.367,0.591c-3.664,1.546-7.512,2.568-11.367,3.449c-3.877,0.799-7.78,1.447-11.707,1.887 c-3.927,0.429-7.865,0.73-11.81,0.851c3.915-0.501,7.825-0.978,11.718-1.552c3.891-0.583,7.773-1.221,11.603-2.083 c3.842-0.799,7.639-1.823,11.299-3.204C326.247,247.476,329.894,245.72,332.382,242.61z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0851B"
    },
    d: "M333.494,239.767c-3.412,1.146-6.922,1.989-10.448,2.713c-3.528,0.725-7.088,1.262-10.644,1.801 c-3.567,0.465-7.131,0.925-10.704,1.313c-3.573,0.387-7.144,0.764-10.727,1.095c3.528-0.71,7.082-1.262,10.636-1.797 l10.667-1.521c3.56-0.462,7.104-1.011,10.644-1.584C326.459,241.21,329.983,240.546,333.494,239.767z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0851B"
    },
    d: "M335.149,237.736c-3.429-0.221-6.851-0.354-10.27-0.319c-3.418,0.038-6.834,0.178-10.229,0.552 c-3.402,0.299-6.78,0.825-10.138,1.464c-3.359,0.637-6.685,1.448-10.002,2.346c3.198-1.261,6.502-2.251,9.856-3.038 c3.354-0.787,6.768-1.312,10.195-1.686c3.434-0.3,6.883-0.455,10.327-0.341C328.329,236.825,331.764,237.138,335.149,237.736z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0851B"
    },
    d: "M335.751,236.684c-1.386-0.639-2.77-1.259-4.21-1.736c-0.708-0.267-1.437-0.474-2.153-0.713 c-0.732-0.192-1.456-0.407-2.191-0.576c-2.937-0.695-5.929-1.154-8.941-1.268c-3.008-0.181-6.035-0.057-9.033,0.328 c-3.001,0.373-5.967,1.009-8.922,1.766c2.837-1.121,5.798-1.941,8.82-2.467c3.023-0.537,6.111-0.658,9.181-0.545 c3.066,0.194,6.125,0.65,9.076,1.505C330.328,233.82,333.174,235.05,335.751,236.684z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#983D68"
    },
    d: "M325.328,297.253c0,0-8.365,0.388-18.77-2.872C311.563,305.786,320.755,305.685,325.328,297.253z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M307.059,295.454c-0.257-0.492-0.263-0.53-0.501-1.074c10.406,3.261,18.77,2.872,18.77,2.872 c-0.096,0.168-0.268,0.485-0.485,0.831C319.34,298.16,312.036,297.27,307.059,295.454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED76AA"
    },
    d: "M316.031,301.184c1.546,0.167,2.723,0.993,2.691,1.863c-1.854,0.483-3.807,0.251-5.681-0.748 C313.302,301.518,314.565,301.026,316.031,301.184z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F9BA57",
      strokeMiterlimit: 10
    },
    d: "M266.104,230.125c-2.372,2.224-3.45,5.575-3.496,8.826 c-0.046,3.251,0.837,6.443,1.886,9.521c0.696,2.041,1.48,4.157,1.193,6.294c-0.193,1.439-0.865,2.783-1.042,4.224 c-0.179,1.454,0.172,2.968,0.973,4.194"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00527B"
    },
    points: "316.629,246.732 261.498,229.609 313.805,205.185 368.936,222.308  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#006792"
    },
    points: "368.938,220.268 313.805,203.144 313.804,205.184 368.936,222.308  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#163F66"
    },
    points: "261.499,227.57 313.805,203.144 313.804,205.184 261.498,229.609  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006792"
    },
    d: "M284.597,258.673c0,0,26.512-16.806,64.176-8.129c-0.234-10.364-0.758-25.441-0.758-25.441 s-40.925-14.972-63.692,7.536C283.947,247.889,284.597,258.673,284.597,258.673z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F49D50"
    },
    cx: 265.754,
    cy: 263.433,
    r: 1.437
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BA56"
    },
    d: "M266.779,262.861c0,0.484-0.392,0.877-0.877,0.877s-0.877-0.392-0.877-0.877 c0-0.484,0.393-0.877,0.877-0.877S266.779,262.376,266.779,262.861z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E48E46"
    },
    d: "M271.988,279.498c0.091,0.798-1.885,1.677-4.413,1.964c-2.528,0.287-4.65-0.127-4.741-0.925 c-0.091-0.798,0.654-5.692,3.181-5.979C268.544,274.272,271.898,278.701,271.988,279.498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BA56"
    },
    d: "M262.846,280.533c-0.815-7.791-1.359-16.215,3.171-16.759 c4.529-0.544,5.979,15.762,5.979,15.762l-2.923-0.079l-0.815-2.467v2.577c0,0-0.551,0.044-0.771,0.132 c-0.286-0.352-0.573-0.793-0.573-0.793l0.088,0.903c0,0-1.3,0.198-1.938,0.374c-0.463-1.366-1.013-3.921-1.013-3.921 l0.176,4.009C264.226,280.272,263.183,280.397,262.846,280.533z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006792"
    },
    d: "M171.511,315.845c-9.677,2.389-18.159,12.305-17.801,19.115c33.093,0,59.615,0,59.615,0 s-2.031-13.978-18.276-18.614C183.864,313.154,171.511,315.845,171.511,315.845"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#825742"
    },
    cx: 182.675,
    cy: 317.651,
    rx: 10.173,
    ry: 4.041
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.517,
    y: 305.242,
    style: {
      fill: "#825742"
    },
    width: 12.515,
    height: 11.265
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#724136"
    },
    d: "M189.032,311.449v-6.207h-12.515v6.479C181.171,312.368,185.876,311.978,189.032,311.449z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    style: {
      fill: "#00527B"
    },
    d: "M183.115,321.021c-7.235,0-8.342-4.306-8.308-5.894 c-2.567,0.101-3.817,0.844-3.817,0.844s1.718,8.309,12.193,8.056c10.476-0.253,11.866-7.682,11.866-7.682 s-0.312-0.34-1.799-0.644c-1.309-0.268-2.094-0.236-2.094-0.236S190.35,321.021,183.115,321.021z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00527B"
    },
    d: "M160.833,321.76c-4.427,4.009-7.336,9.153-7.123,13.2c33.093,0,59.615,0,59.615,0 s-0.626-4.275-3.928-8.88C187.827,335.868,167.231,328.736,160.833,321.76z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D453B"
    },
    d: "M174.147,266.287c-0.245,0-0.491-0.061-0.718-0.19c-4.91-2.779-9.53-2.85-13.403-2.552 c-0.808,0.063-1.506-0.54-1.568-1.344c-0.062-0.804,0.54-1.506,1.344-1.568c4.062-0.312,9.439-0.261,15.065,2.923 c0.702,0.397,0.949,1.288,0.552,1.99C175.15,266.02,174.656,266.287,174.147,266.287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D453B"
    },
    d: "M189.974,266.287c-0.508,0-1.003-0.266-1.272-0.741c-0.396-0.702-0.15-1.593,0.552-1.99 c5.626-3.184,11.007-3.233,15.065-2.923c0.804,0.062,1.406,0.764,1.344,1.568c-0.061,0.804-0.741,1.407-1.568,1.344 c-3.868-0.298-8.492-0.228-13.403,2.552C190.465,266.226,190.218,266.287,189.974,266.287z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#825742"
    },
    d: "M213.706,277.684c-0.952,5.375-4.674,9.21-8.312,8.566c-3.639-0.645-5.817-5.524-4.865-10.9 c0.952-5.375,4.674-9.21,8.312-8.566C212.48,267.429,214.658,272.309,213.706,277.684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#825742"
    },
    d: "M158.808,275.35c-0.952-5.375-4.673-9.21-8.312-8.566c-3.639,0.645-5.817,5.524-4.865,10.9 c0.952,5.375,4.674,9.21,8.312,8.566C157.582,285.605,159.76,280.725,158.808,275.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#825742"
    },
    d: "M154.913,244.885v36.159c0,14.832,12.023,26.855,26.855,26.855h1.27 c14.831,0,26.855-12.023,26.855-26.855v-36.159H154.913z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006667101859057481910000005966505083813954712_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.283,
    y1: 264.3741,
    x2: 174.283,
    y2: 273.8323
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#51290C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#51290C",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.56,
      fill: "url(#SVGID_00000006667101859057481910000005966505083813954712_)"
    },
    d: "M179.229,261.138 c0.97,4.656,1.919,12.156-1.95,13.866c-4.995,2.207-8.938-3.355-8.799-7.724C170.606,263.716,179.229,261.138,179.229,261.138z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148659685449802180710000000807404532025982857_",
    gradientUnits: "userSpaceOnUse",
    x1: 159.2087,
    y1: 266.3904,
    x2: 159.2087,
    y2: 275.8487,
    gradientTransform: "matrix(-0.9916 0.1294 0.1294 0.9916 317.1345 -20.6031)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#51290C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#51290C",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.56,
      fill: "url(#SVGID_00000148659685449802180710000000807404532025982857_)"
    },
    d: "M188.411,261.582 c-0.36,4.742-0.33,12.302,3.727,13.497c5.239,1.542,8.429-4.483,7.726-8.797C197.295,263.023,188.411,261.582,188.411,261.582z "
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#371C11"
    },
    cx: 177.164,
    cy: 273.005,
    rx: 1.063,
    ry: 1.534
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#371C11"
    },
    cx: 193.352,
    cy: 273.005,
    rx: 1.063,
    ry: 1.534
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#371C11"
    },
    d: "M153.102,279.413c0.009,1.913,0.645,3.771,1.811,5.287l0,0l5.347-37.933l7.137,2.071 l38.479,6.967l4.017,28.895l0,0c1.156-1.919,1.784-4.109,1.821-6.348l0.194-11.638c0,0,4.145-12.641-1.736-25.913 c-3.175-7.165-11.444-13.113-26.544-13.987c-13.172-0.762-31.71,3.179-34.412,21.696c-1.721,11.795,1.091,17.778,1.091,17.778 L153.102,279.413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#371C11"
    },
    d: "M175.441,260.589c-5.919,1.544-14.356,8.794-4.915,6.596 C179.968,264.986,184.365,258.261,175.441,260.589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#371C11"
    },
    d: "M192.224,260.589c5.919,1.544,14.356,8.794,4.915,6.596 C187.697,264.986,183.3,258.261,192.224,260.589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FED5A9"
    },
    d: "M203.353,276.128c0,1.08-2.492,1.956-5.566,1.956c-3.074,0-5.566-0.875-5.566-1.956 c0-1.08,2.492-1.956,5.566-1.956C200.861,274.172,203.353,275.047,203.353,276.128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FED5A9"
    },
    d: "M177.176,276.128c0,1.08-2.492,1.956-5.566,1.956c-3.074,0-5.566-0.875-5.566-1.956 c0-1.08,2.492-1.956,5.566-1.956C174.684,274.172,177.176,275.047,177.176,276.128z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#522B23"
    },
    d: "M180.248,280.944c-0.085,0.57,0.247,1.052,0.691,1.293c0.449,0.251,0.975,0.359,1.5,0.412 c1.054,0.115,2.134,0.032,3.204-0.086c1.071-0.142,2.152-0.283,3.062-0.663c0.443-0.196,0.848-0.433,1.066-0.743 c0.223-0.301,0.288-0.674,0.221-1.117c-0.124-0.895-0.664-1.85-1.23-2.736c-0.602-0.952-1.16-1.967-1.535-3.045 c-0.802-2.146-0.94-4.481-0.569-6.661c0.12,2.214,0.589,4.356,1.48,6.289c0.456,0.964,0.984,1.88,1.616,2.753 c0.631,0.944,1.27,1.932,1.487,3.233c0.098,0.639-0.025,1.442-0.486,2.022c-0.449,0.582-1.05,0.899-1.622,1.108 c-1.159,0.402-2.301,0.479-3.419,0.521c-1.124,0.039-2.268-0.009-3.386-0.287c-0.553-0.152-1.11-0.361-1.575-0.733 c-0.226-0.19-0.43-0.427-0.526-0.712C180.132,281.505,180.156,281.204,180.248,280.944z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054242894631304635740000009329034427180841355_",
    gradientUnits: "userSpaceOnUse",
    x1: 262.9413,
    y1: -20.1487,
    x2: 275.8366,
    y2: -30.0991,
    gradientTransform: "matrix(0.9856 0.1688 -0.1688 0.9856 -82.5571 269.3752)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#220900"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4B211C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054242894631304635740000009329034427180841355_)"
    },
    d: "M175.549,289.708 c0,0,8.494,1.455,19.534-0.558C188.527,300.164,179.152,298.898,175.549,289.708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M194.125,290.633c0.324-0.47,0.645-0.958,0.957-1.483c-11.04,2.013-19.534,0.558-19.534,0.558 c0.197,0.503,0.415,0.978,0.645,1.433C181.156,292.348,189.732,292.403,194.125,290.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED76AA"
    },
    d: "M184.547,294.899c-1.601-0.025-2.907,0.67-2.985,1.562c1.833,0.728,3.856,0.738,5.897-0.046 C187.291,295.585,186.064,294.923,184.547,294.899z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F9BA57",
      strokeMiterlimit: 10
    },
    d: "M130.261,230.125c-2.372,2.224-3.45,5.575-3.496,8.826 c-0.046,3.251,0.837,6.443,1.886,9.521c0.696,2.041,1.48,4.157,1.193,6.294c-0.193,1.439-0.865,2.783-1.042,4.224 c-0.179,1.454,0.173,2.968,0.973,4.194"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00527B"
    },
    points: "180.786,246.732 125.655,229.609 177.962,205.185 233.093,222.308  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#006792"
    },
    points: "233.095,220.268 177.962,203.144 177.961,205.184 233.093,222.308  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#163F66"
    },
    points: "125.657,227.57 177.962,203.144 177.961,205.184 125.655,229.609  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006792"
    },
    d: "M148.754,258.673c0,0,26.512-16.806,64.175-8.129c-0.234-10.364-0.758-25.441-0.758-25.441 s-40.925-14.972-63.691,7.536C148.104,247.889,148.754,258.673,148.754,258.673z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F49D50"
    },
    cx: 129.911,
    cy: 263.433,
    r: 1.437
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BA56"
    },
    d: "M130.936,262.861c0,0.484-0.393,0.877-0.877,0.877c-0.484,0-0.877-0.392-0.877-0.877 c0-0.484,0.393-0.877,0.877-0.877C130.543,261.984,130.936,262.376,130.936,262.861z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E48E46"
    },
    d: "M136.145,279.498c0.091,0.798-1.885,1.677-4.412,1.964c-2.528,0.287-4.65-0.127-4.741-0.925 c-0.091-0.798,0.654-5.692,3.181-5.979C132.701,274.272,136.055,278.701,136.145,279.498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BA56"
    },
    d: "M127.003,280.533c-0.815-7.791-1.359-16.215,3.171-16.759 c4.529-0.544,5.979,15.762,5.979,15.762l-2.923-0.079l-0.815-2.467v2.577c0,0-0.551,0.044-0.771,0.132 c-0.286-0.352-0.573-0.793-0.573-0.793l0.088,0.903c0,0-1.3,0.198-1.938,0.374c-0.463-1.366-1.013-3.921-1.013-3.921 l0.176,4.009C128.383,280.272,127.34,280.397,127.003,280.533z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0082CA"
    },
    cx: 392.684,
    cy: 156.328,
    r: 1.452
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M458.424,191.376c0,2.978-2.414,5.392-5.392,5.392c-2.978,0-5.392-2.414-5.392-5.392 c0-2.978,2.414-5.392,5.392-5.392C456.01,185.984,458.424,188.398,458.424,191.376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M464.646,255.665c0,2.291-1.857,4.148-4.148,4.148s-4.148-1.857-4.148-4.148 c0-2.291,1.857-4.148,4.148-4.148S464.646,253.374,464.646,255.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M450.959,296.519c0,1.031-0.836,1.866-1.866,1.866s-1.866-0.836-1.866-1.866 c0-1.031,0.836-1.866,1.866-1.866S450.959,295.488,450.959,296.519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M80.988,232.852c0,0.687-0.557,1.244-1.244,1.244s-1.244-0.557-1.244-1.244 c0-0.687,0.557-1.244,1.244-1.244S80.988,232.165,80.988,232.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M39.096,256.909c0,0.229-0.186,0.415-0.415,0.415c-0.229,0-0.415-0.186-0.415-0.415 c0-0.229,0.186-0.415,0.415-0.415C38.911,256.494,39.096,256.68,39.096,256.909z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M45.318,223.935c0,1.031-0.836,1.866-1.867,1.866s-1.866-0.836-1.866-1.866 c0-1.031,0.836-1.867,1.866-1.867S45.318,222.904,45.318,223.935z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M28.313,309.791c0,2.405-1.95,4.355-4.355,4.355s-4.355-1.95-4.355-4.355 c0-2.405,1.95-4.355,4.355-4.355S28.313,307.386,28.313,309.791z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M52.784,327.211c0,0.802-0.65,1.452-1.452,1.452c-0.802,0-1.452-0.65-1.452-1.452 c0-0.802,0.65-1.452,1.452-1.452C52.134,325.76,52.784,326.41,52.784,327.211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082CA"
    },
    d: "M31.631,367.651c0,1.145-0.928,2.074-2.074,2.074c-1.145,0-2.074-0.928-2.074-2.074 c0-1.145,0.928-2.074,2.074-2.074C30.702,365.577,31.631,366.506,31.631,367.651z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.3deda411157b1e046825a7a30b5e666b.svg";
export { ForwardRef as ReactComponent };